class CarrierOilCalculator extends HTMLElement {
  constructor() {
    super();

    this.carrierOils = {};
    this.calculateButtonEl = this.querySelector("#oil-calculate");
    this.paginateNextURL = this.querySelector("#paginate-next")?.href;

    this.conversionFactors = {
      weight: {
        g: 1,
        kg: 1000,
        oz: 28.3495,
        lb: 453.592,
      },
      volume: {
        ml: 1,
        l: 1000,
        tsp: 4.92892,
        tbsp: 14.7868,
        "fl-oz": 29.5735,
      },
    };
  }

  async connectedCallback() {
    if (this.paginateNextURL) {
      await this.getOils();
    }
    this.initCarrier();

    this.calculateButtonEl.addEventListener("click", () => {
      this.calculate();
    });
  }

  async getOils() {
    // Get original oils
    this.carrierOils = JSON.parse(this.querySelector("#oils").innerText);

    let res;

    try {
      res = await fetch(this.paginateNextURL);
      const resText = await res.text();
      const tempDiv = document.createElement("div");

      tempDiv.innerHTML = resText;
      const newCarrierOils = JSON.parse(
        tempDiv.querySelector("#oils").innerText
      );

      this.carrierOils = {
        ...this.carrierOils,
        ...newCarrierOils,
      };
    } catch (error) {
      console.error(error);
    }
    return false;
  }

  async initCarrier() {
    console.log("init carrier");
    const oilSelect = this.querySelector("#oil");
    const placeholderOption = document.createElement("option");
    placeholderOption.innerText = "Please select...";
    placeholderOption.disabled = true;
    placeholderOption.selected = true;
    oilSelect.appendChild(placeholderOption);
    for (const key in this.carrierOils) {
      const option = document.createElement("option");
      option.value = key;
      option.textContent = this.carrierOils[key].name;
      if (document.body.classList.contains("template-product")) {
        if (this.carrierOils[key].selected) option.selected = true;
      }
      oilSelect.appendChild(option);
    }
    return false;
  }

  calculate() {
    const selectedOil = document.getElementById("oil").value;
    const density = this.carrierOils[selectedOil].density;
    const weight = parseFloat(document.getElementById("weight").value);
    const weightUnit = document.getElementById("weightUnit").value;
    const volume = parseFloat(document.getElementById("volume").value);
    const volumeUnit = document.getElementById("volumeUnit").value;

    let result;

    if (!isNaN(weight) && weight > 0) {
      const weightInGrams = weight * this.conversionFactors.weight[weightUnit];
      const volumeInMl = weightInGrams / density;
      const convertedVolume =
        volumeInMl / this.conversionFactors.volume[volumeUnit];
      document.getElementById(
        "result"
      ).innerText = `Volume: ${convertedVolume.toFixed(2)} ${volumeUnit}`;
    } else if (!isNaN(volume) && volume > 0) {
      const volumeInMl = volume * this.conversionFactors.volume[volumeUnit];
      const weightInGrams = volumeInMl * density;
      const convertedWeight =
        weightInGrams / this.conversionFactors.weight[weightUnit];
      document.getElementById(
        "result"
      ).innerText = `Weight: ${convertedWeight.toFixed(2)} ${weightUnit}`;
    } else {
      document.getElementById("result").innerText =
        "Invalid input. Please enter a valid weight or volume.";
    }
  }
}

customElements.define("carrier-oil-calculator", CarrierOilCalculator);
